import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../uicomponentcss';
// import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';

export interface LanguageCSSStyle extends UIComponentCSSStyle {
    getLanguageContainerCSSStyle(): object;
    getTitleCSSStyle(isSelected: boolean): object;
    getTitleDivCSSStyle(): object;
    getPipeCSSStyle(): object;
}

export class LanguageCSSStyleImpl extends UIComponentCSSStyleImpl implements LanguageCSSStyle {
    getLanguageContainerCSSStyle(): object {
        return {
            display: "flex",
            justifyContents: "center",
            flexFlow: "row wrap",
        };
    }

    getTitleCSSStyle(isSelected: boolean): object {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "40px",
            paddingTop: "5px",
            fontWeight: "bold",//isSelected? 800:0,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h10),
            color: isSelected ? this.getResources().getColor(Colors.color_34) : this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "40px",
            cursor: isSelected ? "default" : "pointer"
        };
    }

    getTitleDivCSSStyle(): object {
        return {
            display: "inline",
            cursor: "pointer"
        };
    }

    getPipeCSSStyle(): object {
        return {
            display: "inline",
            paddingLeft: "4px",
            paddingRight: "4px",
            paddingTop: "14px"
        };
    }

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/header/language/languagecss.tsx